import { Stack } from '@chakra-ui/react'
import { TagSearchList } from '@!/Store/Common/components/TagSearchList'
import { buildSearchUrl } from '@!/Util'

/* 各画面の下部に表示するタグ検索用のリンク一覧 */
export const TagSearchBox = ({ searchTags, genreTabName }) => {
  return (
    <Stack spacing={0} pb={6}>
      {searchTags.map((searchTag, index) => (
        <TagSearchList
          key={index}
          title={searchTag.title}
          tags={searchTag.tags}
          pageUrl={searchTag.url}
          buildSearchUrl={(tag) => buildSearchUrl(searchTag.type, tag, genreTabName)}
        />
      ))}
    </Stack>
  )
}
